import React, { useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { API_PATHS } from "../utils/apiPaths";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";

const CreateProjectForm = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [endDate, setEndDate] = useState("");
  const location = useLocation()
  const {projectId} = location.state || {}

const handleFetch = async (projectId) => {
    // Logique de mise à jour du projet
   const response = await axiosInstance.get(API_PATHS.PROJECT.GET_ALL_BY_ID(projectId))
   setName(response.data?.name);
  setDescription(response.data?.description);
  setEndDate(response.data?.endDate ? response.data?.endDate.split('T')[0] : '');
}
const handleUpdate = async (projectId) =>{
    try {
        const projectData = {
            name,
            description,
            endDate,
          };
        await axiosInstance.put(API_PATHS.PROJECT.UPDATE_PROJECT(projectId), projectData);
        toast.success("Projet mis à jour avec succès !");
    } catch (error) {
        toast.error("Echec de mise à jour du project !");
        console.error("Erreur lors de la mise à jour du projet :", error);
    }
}
  if(projectId){
   handleFetch(projectId);
  }
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    // On construit les données du projet à envoyer
    const projectData = {
      name,
      description,
      startDate: new Date(),
      endDate,
    };

    const response = await axiosInstance.post(API_PATHS.PROJECT.CREATE_PROJECT, projectData);
    toast.success("Projet créé avec succès !"); 

    // Réinitialisation du formulaire
    setName("");
    setDescription("");
    setEndDate("");
  } catch (error) {
    console.error("Erreur lors de la création du projet :", error);
    toast.error("Échec de la création du projet");
  }
};


  return (
    <div className="form-card col-span-3">
    <form onSubmit={handleSubmit}>
      <div className="flex gap-5">
      <input
        type="text"
        placeholder="Nom du projet"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
         className="outline-none"
      />
      <input
        type="text"
        placeholder="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        required
        className="outline-none"
      />
       <div className="flex gap-5">
      <span className="text-md font-medium text-slate-400">date d'echeance</span>
      <input
        type="date"
        placeholder="date de fin"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        required
        className="text-md font-medium text-slate-400"
      />
      </div>
      </div>
      {projectId ? (<button type="button" onClick={() => handleUpdate (projectId)} className="btn-primary disabled:opacity-50 mt-4">Mettre à jour</button>
      ) : (
      <button type="submit" className="btn-primary disabled:opacity-50 mt-4">Créer</button>)}
    </form></div>
  );
};

export default CreateProjectForm;



